import { Badge } from "reactstrap";

import React from "react";
import { FeedbackState } from "../../../Constants/feedbackEnums";
import { feedbackStateService } from "../../../Services/FeedbackStateService";
import { BadgeButton } from "../../../../Layout/Components/BadgeButton/BadgeButton";

type Props = {
  state: FeedbackState;
};

const badgeColors = {
  [FeedbackState.Approved as any]: {
    color: "#006b75",
    textColor: "white"
  },
  [FeedbackState.Completed as any]: {
    color: "#2cbe4e",
    textColor: "white"
  },
  [FeedbackState.Declined as any]: {
    color: "#e11d21",
    textColor: "white"
  },
  [FeedbackState.InDevelopment as any]: {
    color: "#fbca04",
    textColor: "black"
  },
  [FeedbackState.New as any]: {
    color: "#bfbfbf",
    textColor: "black"
  },
  [FeedbackState.CannotReproduce as any]: {
    color: "#ff7300",
    textColor: "white"
  },
  [FeedbackState.NotApplicable as any]: {
    color: "#46e7f2",
    textColor: "black"
  },
  [FeedbackState.PendingReview as any]: {
    color: "#ca38ff",
    textColor: "white"
  },
  [FeedbackState.ReadyForDev as any]: {
    color: "#ff36ab",
    textColor: "white"
  },
  [FeedbackState.Confirmed as any]: {
    color: "#fbff05",
    textColor: "black"
  }
};

export const FeedbackStateBadge: React.FC<Props> = props => {
  const text = feedbackStateService.getDisplayNameForState(FeedbackState[props.state]);

  return (
    <BadgeButton
      {...badgeColors[props.state as any]}
      borderColor={badgeColors[props.state as any].color}
      disabled
    >
      {text}
    </BadgeButton>
  );
};

export default FeedbackStateBadge;
